import {IEnterpriseProgressTag} from "api/types";
import Badge from "pages/recruiter/TalentFinder/Badge";
import {FC, useState} from "react";

interface Props {
  tags: IEnterpriseProgressTag[];
}

export const courses = [
  {id: 955112, name: "Foundations"},
  {id: 577780, name: "Cleanup"},
  {id: 422860, name: "Practice"},
] as const;

const getLevel = (completed: number, total: number) => {
  const progress = (completed / total) * 100;
  if (progress <= 25) return "low";
  if (progress <= 75) return "average";

  return "high";
};

const ProgressTags: FC<Props> = ({tags}) => {
  const [openCourse, setOpenCourse] = useState<number | null>(0);

  const milestones = tags.filter((tag) => tag.isMilestone).sort((a, b) => a.orderIndex - b.orderIndex);
  const totalMilestones = milestones.length;
  const completedMilestones = milestones.filter((tag) => tag.isCompleted).length;

  return (
    <div className="grid gap-4 w-full col-span-2 2xl:col-span-4 pb-5">
      {courses.map((course) => {
        const courseTags = tags.filter((tag) => tag.courseId === course.id).sort((a, b) => a.orderIndex - b.orderIndex);
        const completed = courseTags.filter((tag) => tag.isCompleted).length;
        const total = courseTags.length;

        return (
          <div key={course.id} className="grid gap-2 bg-white border border-brand-border col-span-2 rounded-2.5 p-4">
            <div
              className={`w-full flex items-center justify-between cursor-pointer
               border-b-[0.3px] border-b-[rgba(211, 224, 235, 1)] pb-4 transition-all
               ${openCourse === course.id ? "mb-0" : "-mb-4 hover:mb-0"}`}
              onClick={() => setOpenCourse((old) => (old === course.id ? null : course.id))}
            >
              <span className="text-base text-primary-blue font-semibold">{course.name}</span>
              <Badge level={getLevel(completed, total)}>
                {completed} / {total}
              </Badge>
            </div>
            {openCourse === course.id && (
              <div className="flex flex-col">
                {courseTags.map((tag, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <div
                      className={`w-2.5 h-2.5 rounded-full border-2
                       ${tag.isCompleted ? "border-emerald-500" : "border-emerald-400"} text-emerald-500`}
                    >
                      <svg
                        viewBox="0 0 12 12"
                        className="w-full h-full translate-x-0.5 -translate-y-px"
                        opacity={tag.isCompleted ? 1 : 0}
                      >
                        <path d="M0 6L4 10L12 0" fill="none" stroke="currentColor" strokeWidth="3" />
                      </svg>
                    </div>
                    <span className="text-sm text-primary-blue">{tag.description}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
      <div className="grid gap-2 bg-white border border-brand-border col-span-2 rounded-2.5 p-4">
        <div
          className={`w-full flex items-center justify-between cursor-pointer
               border-b-[0.3px] border-b-[rgba(211, 224, 235, 1)] pb-4 transition-all
               ${openCourse === 0 ? "mb-0" : "-mb-4 hover:mb-0"}`}
          onClick={() => setOpenCourse((old) => (old === 0 ? null : 0))}
        >
          <span className="text-base text-primary-blue font-semibold">Milestones</span>
          <Badge level={getLevel(completedMilestones, totalMilestones)}>
            {completedMilestones} / {totalMilestones}
          </Badge>
        </div>
        {openCourse === 0 && (
          <div className="flex flex-col">
            {milestones.map((tag, index) => (
              <div key={index} className="flex items-center gap-2">
                <div
                  className={`w-2.5 h-2.5 rounded-full border-2
                 ${tag.isCompleted ? "border-emerald-500" : "border-emerald-400"} text-emerald-500`}
                >
                  <svg
                    viewBox="0 0 12 12"
                    className="w-full h-full translate-x-0.5 -translate-y-px"
                    opacity={tag.isCompleted ? 1 : 0}
                  >
                    <path d="M0 6L4 10L12 0" fill="none" stroke="currentColor" strokeWidth="3" />
                  </svg>
                </div>
                <span className="text-sm text-primary-blue">{tag.description}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressTags;
